var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9664 14.2982C15.7883 18.5519 12.2849 21.9461 7.98749 21.9461C3.57611 21.9461 5.607e-06 18.2497 5.607e-06 13.9586C5.607e-06 13.385 -0.0102762 12.2387 0.849738 10.3047C1.36442 9.1473 1.68724 8.42018 1.86942 7.75552C1.96952 7.39022 2.16419 6.80985 2.71915 7.75552C3.04638 8.31311 3.05904 9.11509 3.05904 9.11509C3.05904 9.11509 4.27654 8.18081 5.0984 6.39595C6.30324 3.77936 5.34194 2.21526 5.01343 1.1276C4.89974 0.75134 4.82836 0.0751228 5.60824 0.362842C6.40291 0.656085 8.50379 2.12672 9.60199 3.6768C11.1693 5.88908 11.7263 8.01044 11.7263 8.01044C11.7263 8.01044 12.2282 7.38758 12.4061 6.73584C12.6071 5.99989 12.61 5.27099 13.2558 6.05614C13.8699 6.8028 14.7819 8.20596 15.2952 9.53996C16.2273 11.9625 15.9664 14.2982 15.9664 14.2982Z",
    fill: "url(#paint0_linear_12382_93)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98762 21.946C4.93716 21.946 2.46436 19.4732 2.46436 16.4228C2.46436 14.5822 3.20609 13.4647 4.7498 11.9493C5.73821 10.979 6.66331 9.78722 7.05648 8.97572C7.13389 8.81597 7.31004 7.98349 7.98923 8.95822C8.34553 9.46942 8.90406 10.3785 9.26222 11.1544C9.87963 12.4922 10.027 13.7886 10.027 13.7886C10.027 13.7886 10.6321 13.4321 11.0467 12.514C11.1803 12.2181 11.4505 11.098 12.2059 12.218C12.7602 13.0398 13.5217 14.5175 13.5109 16.4228C13.5109 19.4732 11.038 21.946 7.98762 21.946Z",
    fill: "#FC9502"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07234 15.9128C8.85835 15.9128 8.85835 17.3683 9.85678 19.3118C10.5216 20.6058 9.52717 21.9459 8.07234 21.9459C6.61751 21.9459 5.86304 20.7666 5.86304 19.3118C5.86304 17.857 7.28634 15.9128 8.07234 15.9128Z",
    fill: "#FCE202"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12382_93",
    x1: 7.99948,
    y1: 21.962,
    x2: 7.99948,
    y2: 0.309819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumFire);
export default __webpack_public_path__ + "static/media/medium_fire.8bedad7f7fb26fa83f6ded7d6a92b8e3.svg";
export { ForwardRef as ReactComponent };